<template>
  <v-flex xs12 sm6 md6 lg4 xl3 px-2 mb-2>
    <v-hover>
      <v-card
        color="cardBackground"
        class="px-4 py-2 mb-2 rounded-3"
        slot-scope="{ hover }"
        :class="`elevation-${hover ? 5 : 2}`"
        :to="{ name: 'Case', params: {case_id: caseData.id } }">
        <v-card-title class="pa-0 pb-2 pt-1">
          <v-flex xs12>
          <font-awesome-icon
            color="secondary"
            style="float: left; margin-top: 6px;  margin-right: 9px;" :icon="[caseData.icon.set, caseData.icon.code]">
          </font-awesome-icon>
            <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-1 pb-1 pr-3">{{ caseData.title }}</h3>
          </v-flex>
          <v-flex xs12 pr-4>
            <h4 class="text-truncate">
              <span class="primary--text body-1 opacity-54 pt-1">
                {{ caseData.caseType }} {{ getCaseRef(caseData, caseData.caseType) }} -
              </span>
              <span class="pl-1 pt-1 primary-text body-1 opacity-54 font-weight-bold">
                {{ caseData.currentState }}
              </span>
            </h4>
          </v-flex>
          <v-flex xs12 pr-4>
          <h4>
            <span
              v-if="sla"
              class="body-1 mt-2 pt-0 d-block mb-0 primary-text state--text"
              v-bind:class="slaState">
              {{ sla.serviceLevelCriteria.name }}
            </span>
            <span class="body-1 mt-2 pt-0 d-block mb-0 primary-text" v-else>No Service Levels.</span>
          </h4>
          </v-flex>
        </v-card-title>
        <v-flex v-if="sla" class="severity-border" :class="slaState"></v-flex>
      </v-card>
    </v-hover>
  </v-flex>

</template>

<script>
import { mapState } from "vuex"
import Helpers from "../helpers.js"

export default {
  props: ["caseData"],
  data: () => ({
    summaryFieldsDialog: false
  }),
  computed: {
    ...mapState({
      flaggedCasesLoading: state => state.homepage.flaggedCasesLoading
    }),
    sla() {
      let serviceLevel
      if (this.caseData && this.caseData.serviceLevels) {
        const serviceLevels = this.caseData.serviceLevels.filter(serviceLevel => serviceLevel.active === true)
        if (serviceLevels.length > 0) {
          serviceLevel = serviceLevels[0]
        }
      }
      return serviceLevel
    },
    slaState() {
      if (this.sla) {
        if (this.sla.jeopardizedAt && !this.sla.breachedAt) {
          return "jeopardy"
        }
        if (this.sla.breachedAt) {
          return "breach"
        }
      }
      return ""
    }
  },
  methods: {
    getCaseRef: function(caseData, caseType) {
      return Helpers.getCaseRefField(caseData, caseType)
    },
    toggleCaseFlag: function() {
      this.$store.dispatch("toggleCaseFlag", { caseData: this.caseData })
    }
  }
}
</script>
